import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class ForInHouseCounselsEmployee extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
    };
  }

componentDidMount(){
  this.get_emp_basic_details();
}
get_emp_basic_details(){
    var cutThis           = this;
    var emp_id            = cutThis.props.id;
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var body = new FormData();
    body.append('emp_id',emp_id);
    body.append('web_token',web_token);
    body.append('form_type','employee_for_in_house_counsels_employee');
    body.append('function','get_emp_basic_details');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
    }else{
      url = "/php/admin_employee_management_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['error']==1){
          var new_data = data['data'];
          cutThis.update_info(new_data);
        }

     })
     .catch(function (error) {
         console.log(error);
     });
}

update_info(data){
  $('#declaration_regarding_active_non_active_practice ').val(data['declaration_regarding_active_non_active_practice']);
  $('#any_litigation_handled_independently').val(data['any_litigation_handled_independently']);
  $('#licenses_or_registrations_under_regulatory_bodies').val(data['licenses_or_registrations_under_regulatory_bodies']);
  $('#professional_memberships').val(data['professional_memberships']);
}

add_emp_basic_details(){
  var cutThis           = this;
  var emp_id            = cutThis.props.id;
  var web_token         = window.isNullAndUndef($('#web_token').val());
  var declaration_regarding_active_non_active_practice    = window.isNullAndUndef($('#declaration_regarding_active_non_active_practice').val());
  var any_litigation_handled_independently     = window.isNullAndUndef($('#any_litigation_handled_independently').val());
  var licenses_or_registrations_under_regulatory_bodies            = window.isNullAndUndef($('#licenses_or_registrations_under_regulatory_bodies').val());
  var professional_memberships       = window.isNullAndUndef($('#professional_memberships').val());
  var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
  cutThis.setState({submit_button});
  $('label').removeClass('color_red');
  if(declaration_regarding_active_non_active_practice && any_litigation_handled_independently && licenses_or_registrations_under_regulatory_bodies && professional_memberships){
    var all_data                    = {};
    all_data['declaration_regarding_active_non_active_practice']      = declaration_regarding_active_non_active_practice;
    all_data['any_litigation_handled_independently']       = any_litigation_handled_independently;
    all_data['licenses_or_registrations_under_regulatory_bodies']              = licenses_or_registrations_under_regulatory_bodies;
    all_data['professional_memberships']         = professional_memberships;
    var body = new FormData();
    body.append('emp_id',emp_id);
    body.append('emp_date',JSON.stringify(all_data));
    body.append('web_token',web_token);
    body.append('form_type','employee_for_in_house_counsels_employee');
    body.append('function','add_emp_basic_details');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
    }else{
      url = "/php/admin_employee_management_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        $('#error_msg').text(data['msg']);
        submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
        cutThis.setState({submit_button});
     })
     .catch(function (error) {
         console.log(error);
     });
  }else {
    window.change_lable_color('declaration_regarding_active_non_active_practice','any_litigation_handled_independently','licenses_or_registrations_under_regulatory_bodies','professional_memberships');
    submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
    cutThis.setState({submit_button});
  }

}


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="declaration_regarding_active_non_active_practice" placeholder="Declaration regarding Active/Non-Active Practice"/>
                                        <label for="name">Declaration regarding Active/Non-Active Practice</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="any_litigation_handled_independently" placeholder="Any Litigation Handled Independently"/>
                                        <label for="name">Any Litigation Handled Independently</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="licenses_or_registrations_under_regulatory_bodies" placeholder="Licenses or Registrations under Regulatory Bodies"/>
                                        <label for="name">Licenses or Registrations under Regulatory Bodies</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="professional_memberships" placeholder="Professional Memberships"/>
                                        <label for="name">Professional Memberships</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                <div className="col-md-8">
                                  <p id="error_msg"></p>
                                </div>
                                  <div className="col-md-4 p-0 float_r">
                                      {this.state.submit_button}
                                  </div>
                                </div>


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default ForInHouseCounselsEmployee;
